
  <template>
    <p class="totop"></p>
    <v-card
      class="mx-auto mt-6 d-flex flex-column elevation-0"
      width="300"
    >
      <v-img
          width="300"
          :src="require(`@/assets/emmie_logo_longtext.png`)"
          :alt="`Welcome to emmie.`"
          class="welcomeimg"
      ></v-img>
      <div class="d-flex flex-column align-start">
        <v-card-text class="text-justify pt-1 font-weight-medium textWelcome">
          Verfolge Deinen Menstruationszyklus - für jede Phase Deiner menstruellen und reproduktiven Gesundheit!
        </v-card-text>
      </div>
      <v-spacer></v-spacer>
        <div class="d-flex justify-center ma-4">
        <v-btn
        class="loginButton"
        to="register" link
        width="300"
        color="#ecd4af"
        >
        Los geht's
        </v-btn>
    </div>
    <div class="d-flex justify-center ma-4">
        <router-link :to="{ name: 'login'}">Ich habe bereits ein Konto</router-link>
    </div>
    <iframe src="https://emmie-backend.offis.de" width="1" height="1"></iframe>
    </v-card>
  </template>
  
  <script setup>
  </script>

<style>
    .totop{
        margin-top:70px;
        width:300px;
    }
    .welcomeimg{
        width:300px;
        max-width:300px;
    }
    .logo{
        max-width:150px;
    }
    .textWelcome{
        font-size: 0.9rem;
        line-height: 150%;
        margin: 70px 0 70px 0;
    }
</style>